import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const InstitutionContext = createContext();

export const InstitutionProvider = ({ children }) => {
  const { user } = useAuth();
  const [selectedInstitution, setSelectedInstitution] = useState(() => {
    return localStorage.getItem('institutionId') || '';
  });

  useEffect(() => {
    if (selectedInstitution) {
      localStorage.setItem('institutionId', selectedInstitution);
    } else {
      localStorage.removeItem('institutionId');
    }
  }, [selectedInstitution]);

  // Update selected institution when user profile loads or user logs out
  useEffect(() => {
    if (user?.userprofile?.institution) {
      setSelectedInstitution(String(user.userprofile.institution.id));
    } else if (!user) {
      setSelectedInstitution('');
    }
  }, [user]);

  return (
    <InstitutionContext.Provider value={{ selectedInstitution, setSelectedInstitution }}>
      {children}
    </InstitutionContext.Provider>
  );
};

export const useInstitution = () => useContext(InstitutionContext);
